"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var valid_element_children_1 = __importDefault(require("../util/valid-element-children"));
var panel_1 = require("./panel");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var Accordion = /** @class */function (_super) {
  __extends(Accordion, _super);
  function Accordion() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      activeKey: _this.props.defaultActiveKey
    };
    _this._isChanging = false;
    _this.handleSelect = function (key, event, expanded) {
      event.preventDefault();
      var onSelect = _this.props.onSelect;
      if (onSelect) {
        _this._isChanging = true;
        onSelect(key, event, expanded);
        _this._isChanging = false;
      }
      if (_this.state.activeKey === key) {
        key = null;
      }
      _this.setState({
        activeKey: key
      });
    };
    _this.renderPanel = function (child, index) {
      var activeKey = _this.props.activeKey != null ? _this.props.activeKey : _this.state.activeKey;
      var props = {
        key: child.key ? child.key : index,
        ref: child['ref'],
        headerRole: 'tab',
        panelRole: 'tabpanel',
        collapsible: true,
        onSelect: _this.handleSelect,
        expanded: _this.props.autoCollapse ? child.props.eventKey === activeKey : child.props.expanded
      };
      return react_1.default.cloneElement(child, props);
    };
    return _this;
  }
  Accordion.prototype.shouldComponentUpdate = function () {
    // Defer any updates to this component during the `onSelect` handler.
    return !this._isChanging;
  };
  Accordion.prototype.render = function () {
    var _a;
    var _b = this.props,
      className = _b.className,
      children = _b.children,
      type = _b.type;
    var customProps = _1.omit(this.props, Object.keys(Accordion.propTypes));
    var accordionClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('accordion')] = true, _a[vdl_prefix_1.vdlPrefix("accordion--" + type)] = true, _a);
    return react_1.default.createElement("div", __assign({}, customProps, {
      role: "tablist",
      className: classnames_1.classNames(className, accordionClasses)
    }), valid_element_children_1.default.map(children, this.renderPanel));
  };
  Accordion.propTypes = {
    activeKey: prop_types_1.default.any,
    defaultActiveKey: prop_types_1.default.any,
    onSelect: prop_types_1.default.func,
    autoCollapse: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    type: prop_types_1.default.oneOf(['pills', 'default']),
    children: prop_types_1.default.node
  };
  Accordion.defaultProps = {
    autoCollapse: false,
    type: 'default'
  };
  Accordion.Panel = panel_1.Panel;
  return Accordion;
}(react_1.default.Component);
exports.Accordion = Accordion;